import {
  getTransitionDuration,
  getBreakpoints,
  viewportSize
} from './utils.js'


let enableConsoleLogs = true
let logger = (...msg) => enableConsoleLogs && console.log(...msg)


export default class TableOfContents extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    logger('table-of-contents connected', this)

    this.headingEl = this.querySelector('[data-toc-heading]')
    this.contentsEl = this.querySelector('[data-toc-contents]')
    this.breakpoints = getBreakpoints(this)

    if (viewportSize(this.breakpoints.sm, this.breakpoints.lg).isSm.matches) {
      this.setup()
    }

    // Watch for viewport changes
    viewportSize(this.breakpoints.sm, this.breakpoints.lg).isSm.addListener(this.handleBreakpoint.bind(this))
  }

  disconnectedCallback() {
    viewportSize(this.breakpoints.sm, this.breakpoints.lg).isSm.removeListener(this.handleBreakpoint.bind(this))
  }

  setup() {
    this.detailsEl = document.createElement('details')
    this.summaryEl = document.createElement('summary')
    this.summaryEl.setAttribute('data-toc-heading', '')
    this.summaryEl.innerText = this.headingEl.innerText

    this.detailsEl.append(this.summaryEl)
    this.detailsEl.append(this.contentsEl)
    this.headingEl.remove()

    this.append(this.detailsEl)
  }

  destroy() {
    this.append(this.headingEl)
    this.append(this.contentsEl)
    this.detailsEl.remove()
  }

  handleBreakpoint() {
    if (viewportSize(this.breakpoints.sm, this.breakpoints.lg).isSm.matches) {
      this.setup()
    } else {
      this.destroy()
    }
  }
}
